/*
Failure reasons that are returned from withPieEncryption component from @vz-soe-utils/pieencryption package
 */
export const PIE_ENCRYPT_FAILURE_REASONS = {
  CHECKSUM_ERROR: 'CHECKSUM_ERROR',
  SCRIPT_ERROR_PCI: 'withPieEncryption::pieProtectPCI:: pie scripts are errored',
  SCRIPT_LOAD_ERROR_PCI: 'withPieEncryption::pieProtectPCI:: pie scripts are not loaded',
  SCRIPT_ERROR_SPI: 'withPieEncryption::pieProtectSPI:: pie scripts are errored',
  SCRIPT_LOAD_ERROR_SPI: 'withPieEncryption::pieProtectSPI:: pie scripts are not loaded',
};

/* Verbiage */
export const DEFAULT_ERR_MSG = 'We are unable to process the request at this time. Please try after sometime';

export const errors = {
  DT_OD_CHECKOUT_PAYMENT_PAN_CHECKSUM_ERROR: 'The credit/debit card you submitted has been declined. Please choose another saved card or enter a new one.',
  DT_OD_CHECKOUT_PAYMENT_GC_ENCRYPTION_ERROR: 'The Gift Card Number or the PIN used is invalid.',
};

export const preFetchConsts = {
  SESSION_KEY: 'preFetch',
  QUERYSTRING_KEY: 'preFetch',
};

export const commonErrors = {
  defaultMessage: 'Looks like something went wrong. Please try again later.',
   transactionExpired: '<p>Your transaction has expired. Please <a id="transactionExpiryLink" className="transactionLink"> retry the flow</a></p>',
  systemError: 'There is a problem with one of our systems. Please try again later.',
  plansPageRedirect: '<p>Plan is missing from cart. Please  <a href id="planLink"> choose a plan</a> to continue checkout</p>',
  };

  export const CART_CONTACT_INFO_INTG = 'integratedCartContactInfo';

  export const cradleThrottleValues = {
    CART_CONTACT_INFO_INTG_PASSKEY : 'cart-contactinfo-intg',
    CART_CONTACT_INFO_INTG_ENABLED : '|intgContactInfo|',
    CART_CONTACT_INFO_INTG_DISABLED : '|intg_C_ContactInfo|',
    CART_CONTACT_INFO_INTG_WHITELISTED : '|intgContactInfo-wl|',
    CART_CONTACT_INFO_INTG_BLACKLISTED : '|intg_C_ContactInfo-bl|',
    AUTOPAY_PREVIEW_ENABLED: 'autopay-preview',
    AUTOPAY_PREVIEW_DISABLED: 'autopay-C-preview',
  }